import { render, staticRenderFns } from "./SiteRevenueStatement.vue?vue&type=template&id=470953d6"
import script from "./SiteRevenueStatement.vue?vue&type=script&lang=js"
export * from "./SiteRevenueStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports